<template>
    <div :class="['form-group']">
        <label :for="id" v-if="label">{{ label }}</label>
        
        <div :class="['form-select2']">
            <select
                :id="id"
                :name="name"
                :value="value"
                :disabled="disabled"
                :class="['form-control form-select2']"
                @focus="focusEvent"
            >
                <option></option>
                <option
                    v-for="(item, index) in listagem"
                    :key="'item-' + index"
                    :value="item.value"
                    :selected="value == item.value"
                >
                    {{ item.text }} 
                </option>
            </select>
            <a
                @click="clearSelect"
                v-if="value !== '' && clear && !disabled"
                class="clear-select"
                >
                </a>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    name: "form-select2",
    props: {
        name: {
            type: String,
            default: "",
        },
        id: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        value: {
            default: "",
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        v: {
            type: Object,
            default: [],
        },
        dropdownParent: {
            type: String,
            default: "body",
        },
        search: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "Selecione",
        },
        exit: {
            type: Boolean,
            default: false,
        },
        clear: {
            type: Boolean,
            default: true,
        },
        listagem: {
            type: Array,
            default: [],
        },
        noResults: {
            type: String,
            default: "Nenhum resultado encontrado",
        },
    },
    watch: {
        value: function (newValue, oldValue) {
            if (oldValue == "") {
                this.atualiza();
            }
        },
        listagem: function (newValue, oldValue) {
            if (oldValue !== newValue) {
                this.atualiza();
            }
        },
    },
    methods: {
        formatState(state){
            if(state.text != 'Searching…'){
                let itemAtual = this.listagem.filter(item => item.value == state.id)
                if(itemAtual[0].icon == 1){
                    return $('<span> '+ state.text + '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+'<g clip-path="url(#clip0_2783_6594)">'+'<path d="M7.33333 5.50008H6.83333V6.00008V10.6667V11.1667H7.33333H8.66667H9.16667V10.6667V6.00008V5.50008H8.66667H7.33333ZM0.842271 14.8334L8 1.71091L15.1577 14.8334H0.842271ZM6.66667 12.6667C6.66667 13.4029 7.26386 14.0001 8 14.0001C8.73614 14.0001 9.33333 13.4029 9.33333 12.6667C9.33333 11.9306 8.73614 11.3334 8 11.3334C7.26386 11.3334 6.66667 11.9306 6.66667 12.6667Z" fill="#EF5350" stroke="#EF5350"/>'+'</g>'+'<defs>'+'<clipPath id="clip0_2783_6594">'+'<rect width="16" height="16" fill="white"/>'+'</clipPath>'+'</defs>'+'</svg> '+'</span>')
                }
                return $('<span> '+ state.text +'</span>')
            }
        },
        clearSelect() {
            $(".form-select2#" + this.id)
                .val("")
                .trigger("change");
        },
        updateSelectValue: function (value) {
            this.$emit("input", value);
            this.$emit("change");
        },
        focusEvent: function () {
            this.$emit("focus");
        },
        atualiza() {
            let vm = this;
            $(document).ready(function () {
                $(".form-select2#" + vm.id)
                    .select2({
                        placeholder: vm.placeholder,
                        minimumResultsForSearch: vm.search ? 0 : Infinity,
                        disabled: vm.disabled,
                        dropdownParent: $(vm.dropdownParent),
                        language: {
                            noResults: function () {
                                return vm.noResults;
                            },
                        },
                        templateResult: vm.formatState
                    })
                    .on("change", function () {
                        vm.updateSelectValue(this.value);
                    });
            });

            $(".form-select2#" + vm.id).one("select2:open", function (e) {
                $("input.select2-search__field").prop(
                    "placeholder",
                    "Pesquise aqui"
                );
            });
            document
                .getElementsByClassName("modal-content")[0]
                // .removeAttribute("tabindex");
        },
    },
    mounted() {
        this.atualiza();
    },
};
</script>

<style lang="scss">
.form-select2 {
    &.select-error {
        .select2-container--default .select2-selection--single {
            border-color: #ed5666 !important;
        }
    }
    position: relative;
    .clear-select {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 24px;
        .icon-clear-select {
            width: 11px;
            height: auto;
            border-radius: 100%;
            &.icon-clear-select:hover {
                background-color: #8d6e63;
                path:nth-child(2) {
                    fill: #fff;
                }
            }
        }
    }
}

.select2-container--default .select2-search--dropdown{
    padding: 20px 21px 12px 21px !important;
}
.select2-search__field {
    border-radius: 3px;
}
.select2-search__field::placeholder {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #CFC4BE;
}

.select2-selection__rendered {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #6e6b7b !important;
    padding-right: 35px !important;
}
.select2-results__option {
    color: #373737;
    font-size: 14px;
    line-height: 17px;
    font-family: "Open Sans";
    .select2-results__option--selected {
        background-color: #e9ecef !important;
        color: #676a6c !important;
        &.select2-results__option--selected:hover {
            background-color: #5897fb !important;
            color: #fff !important;
        }
    }
}

.select2-container {
    width: 100% !important;
}
.select2-container--open {
    z-index: 3000;
    .select2-dropdown--below {
        margin-top: 2px;
        border-top: 1px solid #aaa;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14),
            0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
    }
    .select2-dropdown {
        border-radius: 3px;
    }
}
.select2-selection {
    &.select2-selection--single {
        border-bottom-left-radius: 3px !important;
        border-bottom-right-radius: 3px !important;
    }
    position: relative;
    .select2-selection__arrow {
        position: absolute;
        background-color: transparent;
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.47162 3.05602L5.00158 7.5909L0.528469 3.05593L1.17644 2.40774L4.73416 6.02906L5.00178 6.30146L5.26928 6.02894L8.82368 2.40785L9.47162 3.05602Z' fill='%23CFC4BE' stroke='%23CFC4BE' stroke-width='0.75'/%3E%3C/svg%3E");
        top: 0px !important;
        right: 14px;
        background-repeat: no-repeat;
        background-position-x: calc(100% - 50%);
        background-position-y: 90%;
    }
    b {
        display: none !important;
    }
    .select2-selection__placeholder {
        color: #373737 !important;
        font-size: 14px;
        line-height: 1.2em;
    }
}
.select2-container--default .select2-results__option--selected{
    background-color: #974900;
    span{
        color: #ffffff;
        svg{
            path{
                stroke: #ffff;
                fill: #ffff;
            }
        }
    }
}
.select2-container--default .select2-results__option[aria-selected=true] {
    background-color: #FBEEE8 !important;
    span{
        color: #974900;
        svg{
            path{
                stroke: #974900 !important;
                fill: #974900 !important;
            }
        }
    }
}
.select2-results__option--selectable{
    padding: 12px 21px !important;
}
.select2-results__options {
    span{
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #9F8D83;
        display: flex;
        justify-content: space-between;
    }
}

.select2-results__options {

    &::-webkit-scrollbar {
        width: 5px;
        height: 5px !important;               /* width of the entire scrollbar */
        border-radius: 50%;
      }
      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #FBEEE8;   
        
      }
      &::-webkit-scrollbar-thumb {
        background-color: #CFC4BE;    /* color of the scroll thumb */
        border-radius: 20px;       /* roundness of the scroll thumb */
        border: 10px solid transparent
      }
}


</style>
